<template>
  <div class="question-input-checkbox">
    <b-field
      v-for="choice in choices"
      :key="getChoice(choice)"
    >
      <b-checkbox
        v-model="answers"
        :native-value="getChoice(choice)"
        @input="$emit('answered', answers)"
      >
        <QuestionChoice :choice="choice" />
      </b-checkbox>
    </b-field>
  </div>
</template>


<script>
import QuestionChoice from './QuestionChoice.vue';

export default {
  name: 'QuestionInputCheckbox',
  components: { QuestionChoice },
  props: ['choices', 'prevAnswer'],
  data() {
    return {
      answers: this.prevAnswer ? [...this.prevAnswer] : [],
    };
  },
  computed: { /*
      Creates a new property
      Updates when any dependant property changes */
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    getChoice(choice) {
      if (typeof choice === 'string') return choice;
      return choice.text;
    },
  },
};
</script>


<style scoped>

</style>
